import Loader from "react-loader-spinner";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, FileEarmarkPost, JournalText, List, PrinterFill } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ModalSelectProductGroup from "../Components/ModalSelectProductGroup";
import { exportToExcel, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../store/api/Invoice";
import BihamtaTable from "../../Components/BihamtaTable";
import { getStorageStatusReport, setTurnoverFilters } from "../store/api/ReportsAPI";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBroom, faWarehouse } from "@fortawesome/free-solid-svg-icons";

const StorageStatusReport = () => {
    const frmFilters = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const [selectedPG, selectPG] = useState(null);
    const [pending, setPending] = useState(false);
    const [popPG, setPopPG] = useState({ show: false });
    const [showFilter, setShowFilter] = useState(true);
    const [selectedStorage, selectStorage] = useState(null);
    const [popProducts, setPopProducts] = useState({ show: false });
    const [selectedProduct, selectProduct] = useState(null);
    const [popStorage, setPopStorage] = useState({ show: false });
    const settingNames = ["ProductGrouppingType"];
    const { filterData, systemSettings } = useSelector(state => {
        return {
            filterData: state.ReportReducer.stgStatusReportFilters,
            systemSettings: state.InvoiceReducer.systemSettings
        }
    })
    const productGrouppingType =
        Number(systemSettings?.find?.(s => s.SettingName === "ProductGrouppingType").SettingValue??"1");
    const { handleSubmit, register } = useForm();
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        if (data.ShowZNCounts && Array.isArray(data.ShowZNCounts)) {
            data.ShowZNCounts = data.ShowZNCounts.some(s => s === "on");
        }
        data.Skip = 0;
        dispatch(getStorageStatusReport(data))
    }
    function showModalPG(e) {
        if (e.key && !keyIsLetterOrNumber(e.keyCode, e.key)) {
            return;
        }
        e.preventDefault();
        setPopPG({
            show: true,
            onSelect: selectPG,
            selectOne: true
        })
    }
    function showModalStorage(e) {
        if (e.key && !keyIsLetterOrNumber(e.keyCode, e.key)) {
            return;
        }
        e.preventDefault();       
        setPopStorage({
            show: true,
            setStorageData: selectStorage,
            value: e.key
        })
    }
    function showModalProducts(e) {
        if (e.key && !keyIsLetterOrNumber(e.keyCode, e.key)) {
            return;
        }
        e.preventDefault();
        if (filterData?.ProductID) {
            filterData.ProductID = null;
        }
        setPopProducts({
            show: true,
            value: e.key,
            forStorageReport: true,
            setProductData: selectProduct,

        })
    }
    function showTurnover(row) {

        dispatch(setTurnoverFilters({
            ProductID: row.ProductID,
            ProductName: row.ProductName,
            ProductModel: row.ProductModel,
            StorageName: row.StorageName,
            StorageID: row.StorageId,
            FromStorageStatus: true,
            Take: -1
        }))
        history.push(`/Sale/InventoryTurnoverReport`)
    }
    function toExcel() {
        const url = "api/StorageAPI/GetStorageStatusReport";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        setPending(true);
        exportToExcel("StorageStatusReport", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        history.push({
            pathname: `/PrintViewer/StorageStatusReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/StorageAPI/GetStorageStatusReport`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function clearFilters() {
        frmFilters.current.reset();
        selectPG(null);
        selectStorage(null);
        selectProduct(null);
        dispatch(getStorageStatusReport({ Skip: 0, Take: 0 }));
    }
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "KalaCode", colTitle: "کد کالا", showInMobile: true },
        {colName:"HolderName", colTitle:"مارک کالا", showCondition:()=> productGrouppingType !== 1},
        { colName: "ProductName", colTitle: productGrouppingType === 1 ? "نام کالا" : "نوع کالا", showInMobile: true },
        { colName: "ProductModel", colTitle: "مدل کالا", showInMobile: true },
        { colName: "StorageName", colTitle: "نام انبار" },
        { colName: "SecondName", colTitle: "نشانی در انبار" },
        { colName: "KalaCount", colTitle: "تعداد" },
        { colName: "KalaCountInStartDuration", colTitle: "موجودی اول دوره" },
        { colName: "KalaMeanAvgPrice", colTitle: "میانگین موزون", colType: "currency" },
        { colName: "KalaLastPurchasePrice", colTitle: "قیمت آخرین خرید", colType: "currency" },
        { colName: "KalaLastSalePrice", colTitle: "قیمت آخرین فروش", colType: "currency" }
    ]
    const tableRowBtns = [
        {
            type: "common", tooltip: "نمایش کاردکس", title: "نمایش کاردکس", className: "group-Btn-smalll", icon: <FileEarmarkPost color="#1e76c4" size={21} className="rowBtn" />, onclick: showTurnover
        }
    ]
    useEffect(() => {
        document.body.classList = 'notMain';
        dispatch(getSystemSettings(settingNames));
    }, [])
    return (
        <div className="container-fluid mt-4">
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faWarehouse} size="lg" />&nbsp;
                    گزارش وضعیت انبارها
                </Card.Header>
                <ModalSelectProductGroup popData={popPG} setPopData={setPopPG} />
                <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
                <ModalProducts popData={popProducts} setProductPopup={setPopProducts} productGrouppingType={productGrouppingType} />
                <Card.Body className="bodyStyle">
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder" >
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <input type="hidden" name="ProductID" ref={register({})} readOnly value={selectedProduct?.ProductID ?? filterData.ProductID ?? ""}/>
                                <input className="search-input" name="ProductName" placeholder="مشخصات کالا" ref={register({})} readOnly value={selectedProduct?.ProductName ? (selectedProduct.ProductName+"-"+selectedProduct.ProductModel): filterData?.ProductName ?? ""} onKeyDown={showModalProducts} />
                                <Button className="btn-input-tiny" style={{ top: "5px" }} onClick={showModalProducts}><List size={16} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                            <input type="hidden" name="StorageID" ref={register({})} readOnly value={selectedStorage?.StorageID ?? filterData?.StorageID ?? ""}/>
                                <input className="search-input" name="StorageName" ref={register({})} readOnly value={selectedStorage?.StorageName ?? filterData?.StorageName ?? ""} placeholder="نام انبار"
                                    onKeyDown={showModalStorage} />
                                <Button className="btn-input-tiny" style={{ top: "5px" }} onClick={showModalStorage}><List size={16} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                            <input className="search-input" name="ProductSecondName" placeholder="نشانی در انبار" ref={register({})} defaultValue={filterData?.ProductSecondName ??""} />
                            </Col>
                            {productGrouppingType !== 0 &&
                            <Col md={2} className="form-group">
                            <input type="hidden" value={selectedPG?.GroupID ?? filterData?.GroupID ??""} name="GroupID"ref={register({})}/>
                                <input className="search-input" name="GroupName" ref={register({})} readOnly value={selectedPG?.GroupName ?? filterData?.GroupName ?? ""} placeholder="گروه کالا"
                                    onKeyDown={showModalPG} />
                                <Button className="btn-input-tiny" style={{ top: "5px" }} onClick={showModalPG}><List size={16} /></Button>
                            </Col>}
                            {/* <Col md={2} className="form-group" style={{ display: "flex", alignItems: "center", maxWidth: "fit-content" }}>
                                <div className="rowBorder mt-2" style={{ padding: "6px" }}>
                                    <input type="checkbox" className="form-check-input" name="ShowZNCounts" ref={register({})} defaultChecked={filterData?.ShowZNCounts ?? false} />&nbsp;
                                    <label>نمایش موجودی صفر و منفی</label>
                                </div>
                            </Col> */}
                            <Col md={1} className="form-group">
                            <input type="number" className="search-input" ref={register({})} name="CountFrom" defaultValue={filterData?.CountFrom??"0"} placeholder="از تعداد"/>
                            </Col>
                            <Col md={1} className="form-group">
                            <input type="number" className="search-input" ref={register({})} name="CountTo" defaultValue={filterData?.CountTo??""} placeholder="تا تعداد"/>
                            </Col> 
                            <Col md={2} className="form-group">
                                <select className="search-input" name="Take" ref={register({})} defaultValue={filterData?.Take ?? 10}>
                                    <option value={10}>نمایش 10 ردیف در صفحه</option>
                                    <option value={20}>نمایش 20 ردیف در صفحه</option>
                                    <option value={30}>نمایش 30 ردیف در صفحه</option>
                                    <option value={50}>نمایش 50 ردیف در صفحه</option>
                                    <option value={100}>نمایش 100 ردیف در صفحه</option>
                                    <option value={-1}>نمایش تمام ردیفها در صفحه</option>
                                </select>
                            </Col>                                                       
                        </Row>
                        <Button type="submit" variant="secondary" className="group-Btn-large mt-1"><JournalText size={18} />&nbsp;نمایش گزارش</Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} rowButtons={tableRowBtns} filterData={filterData} searchMethod={(data) => dispatch(getStorageStatusReport(data))} reducerName="ReportReducer" objectName="storageStatusReport" hasPaging={true} maxHeight={400}/>
                </Card.Body>
            </Card>
        </div>
    )

}
export default StorageStatusReport
